import React from 'react';
import PropTypes from 'prop-types';

const TemplateStore = require('../../stores/template_store_reflux');
const verUtil = require('../../util/version.js');

const propTypes = {
    className: PropTypes.string,
    activity: PropTypes.shape({ template_id: PropTypes.number.isRequired, version: PropTypes.string.isRequired, latest_published_version: PropTypes.string }).isRequired
};

const defaultProps = {};


class ActivityIcon extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            templateStoreState: TemplateStore.getStateTemplateById(props.activity.template_id)
        };

        this.unsubscribes = [TemplateStore.listen(this.onTemplateStoreChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onTemplateStoreChange(newState) {
        this.setState({ templateStoreState: TemplateStore.getStateTemplateById(this.props.activity.template_id) });
    }

    render() {
        if (!this.state.templateStoreState.initialized) {
            return null;
        }

        const template = this.state.templateStoreState.template;

        if (!template) {
            console.error(`ActivityIcon: Template ID ${this.props.activity.template_id} not found in store.`);
            return null;
        }

        const curActVersion = verUtil.parseVersion(this.props.activity.version);
        const everPublished = !!this.props.activity.latest_published_version;
        const unpublishedChanges = curActVersion.patch !== 0 || !everPublished;
        const pubIconPath = `${GlobalConfig.StaticUrl}/img/templates/${template.no_changes_icon}`;
        const unpubIconPath = `${GlobalConfig.StaticUrl}/img/templates/${template.unpublished_changes_icon}`;

        return (
            <img
            className={`act-icon ${this.props.className}`}
            src={unpublishedChanges ? unpubIconPath : pubIconPath}
            alt={unpublishedChanges ? `${template.name} Activity with Unpublished Changes` : `Published ${template.name} Activity`}
            />
        );
    }
}

ActivityIcon.propTypes = propTypes;
ActivityIcon.defaultProps = defaultProps;

export default ActivityIcon;